import React, { useContext, useEffect, useState } from "react";
import "./workorder.css";
import Application from "../../../StateContext/Application.js";
import { apiurl } from "../../../../../path.js";
import {
  AddFile32,
  VendorName32,
  Bank32,
  barely_black_bg_img,
  Cancel32,
  Email32,
  Location32,
  PhoneNumber32,
  submit,
} from "../../../../../public/LoginImages/importimages";
import Select from "react-select";


// 27-10 for cal
const pad = (n) => String(n).padStart(2, "0");

const toLocalInput = (value) => {
  if (!value) return "";
  const d =
    value instanceof Date ? value : new Date(String(value).replace(" ", "T"));
  if (isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const getCurrentDateTime = () => toLocalInput(new Date());

const CreateWorkOrder = ({
  projectID,
  budgetHeadID,
  isEdit = false,
  projectDatainward,
  onSuccess,
  onCancel,
}) => {
  const operation = useContext(Application);
  const { GetTotalEstimationForWorkOrder } = operation; // API to get total estimation amount
  const { GetProjectInfo, GetBudgetHeadInfo, WorkOrderCreation } = operation;
  const [projectId, setProjectId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [HeadId, setHeadID] = useState([]);
  const [relatedHeadID, setRelatedHeadID] = useState([]);
  const [Contractor, setContractor] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [IsEdit, setIsEdit] = useState(null);
  const [EditProjectId, setEditProjectId] = useState(null);
  // 21-09
  const [selectedCopyFile, setSelectedCopyFile] = useState(null);
const [removeCopyFile, setRemoveCopyFile] = useState(false);
const [errors, setErrors] = useState({}); //09-10 error msg
 
  const [data, setData] = useState({
    FinancialYear: "",
    ProjectName: "",
    ProjectID: "",
    ProjectCost: "0",
    piu: "",
    GRCopy: "",
    ProjectEstCompletionDate: "",
    BudgetHeadID: "",
    BudgetHeadName: null,
    ContractorName: "",
    Account_Number: "",
    WorkName: "",
    WorkOrderNo: "",
    WorkOrderDate: "",
    WorkEndDate: "",
    ApprovedWorkAmount: 0,
    EstimationAmount: 0,
    PaidAmount: 0,
    RemainingAmount: 0,
    Scheme: "",
    CopyOfWorkOrder:"", //21-09
  });
  const getMinDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const [Scheme, setSchemeType] = useState("");

  const minDateTime = getMinDateTime();
  // 27-10 for cal
  const HandleChangeData = (e) => {
  const { name, value } = e.target;

  if (name === "WorkOrderDate" || name === "WorkEndDate") {
    if (value) {
      const year = value.split("-")[0];
      if (year.length > 4 || !/^\d{1,4}$/.test(year)) return;
    }

    if (
      name === "WorkEndDate" &&
      data.WorkOrderDate &&
      value &&
      new Date(value) < new Date(data.WorkOrderDate)
    ) {
      alert("Work End Date cannot be earlier than Work Order Date");
      return;
    }

    if (
      name === "WorkOrderDate" &&
      data.WorkEndDate &&
      value &&
      new Date(value) > new Date(data.WorkEndDate)
    ) {
      alert("Work Order Date cannot be later than Work End Date");
      return;
    }
  }

  if (
    name === "ApprovedWorkAmount" ||
    name === "PaidAmount" ||
    name === "RemainingAmount"
  ) {
    if (parseFloat(value) < 0) return;
  }

  setData((prev) => ({ ...prev, [name]: value }));
  setErrors((prev) => ({ ...prev, [name]: "" }));
};


// 27-10
const handleDateTimeChange = (e) => {
  const input = e.target;
  const name = input.name;
  let value = input.value;

  const prevDate = toLocalInput(data[name]).split("T")[0];
  const newDate = (value || "").split("T")[0];
  const dateChanged = newDate !== prevDate;

  // Minimum allowed value for this field ("" = no minimum, e.g. in edit mode)
  const minValue =
    name === "WorkEndDate"
      ? toLocalInput(data.WorkOrderDate) || (isEdit ? "" : minDateTime)
      : isEdit
        ? ""
        : minDateTime;

  // If the picked date equals the minimum date, keep the time from
  // going below the minimum (avoids an invalid time on that day).
  if (
    dateChanged &&
    value &&
    minValue &&
    newDate === minValue.split("T")[0] &&
    value < minValue
  ) {
    value = minValue;
  }

  HandleChangeData({ target: { name, value } });

  if (!newDate) return;

  // If the field was empty, compare against the date the picker opens on
  const baseline = prevDate || (minValue || getCurrentDateTime()).split("T")[0];

  const [py, pm, pd] = baseline.split("-").map(Number);
  const [ny, nm, nd] = newDate.split("-").map(Number);

  const monthChanged = py !== ny || pm !== nm;
  const daysInNewMonth = new Date(ny, nm, 0).getDate();

  // Month arrows keep the same day (or clamp it, e.g. 31 -> 30)
  const isArrowNavigation =
    monthChanged &&
    (pd === nd || (nd === daysInNewMonth && pd > daysInNewMonth));

  // Only the time was changed (same date as before)
  const isTimeOnly = prevDate && newDate === prevDate;

  // Close only when a date was actually clicked
  if (!isArrowNavigation && !isTimeOnly) {
    setTimeout(() => input.blur(), 0);
  }
};
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (loading) return;
  //   if (
  //     data.ContractorName === "" ||
  //     data.WorkName === "" ||
  //     data.WorkOrderNo === "" ||
  //     data.WorkOrderDate === "" ||
  //     data.WorkEndDate === ""
  //   ) {
  //     alert("Please fill all the fields");
  //     return;
  //   }
  //   if (Number(data.ApprovedWorkAmount) > Number(data.EstimationAmount)) {
  //     alert("Approved Work Amount cannot be greater than Estimation Amount");
  //     return;
  //   }
  //   setLoading(true);

  //   const formData = new FormData();

  //   Object.keys(data).forEach((key) => {
  //     formData.append(key, data[key]);
  //   });

  //   formData.append("type", isEdit ? "Update" : "Create");

  //   if (isEdit) {
  //     formData.append("WorkOrderID", projectDatainward.WorkOrderID);
  //   }

  //   const file = document.getElementById("CopyOfWorkOrder").files[0];

  //   if (file) {
  //     formData.append("CopyOfWorkOrder", file);
  //   }

  //   const CopyOfWorkOrder = document.getElementById("CopyOfWorkOrder").files;
  //   if (CopyOfWorkOrder) {
  //     formData.append("CopyOfWorkOrder", CopyOfWorkOrder[0]);
  //   }
  //   setLoading(true);

  //   try {
  //     const result = await WorkOrderCreation(formData);
  //     console.log(result);
  //     if (result.message) {
  //       alert(result.message);
  //       if (isEdit) {
  //         onSuccess(); // Hide form & show table again
  //       } else {
  //         window.location.reload();
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // previous handlesumbit take to much tim eto sumbit .this function on 10-09
  const handleSubmit = async (e) => {
  e.preventDefault();
 
 // 18-09
// if (!file) { alert("Please upload Copy of Work Order"); return; }
  const approvedAmount = Number(
    String(data.ApprovedWorkAmount || "").replace(/,/g, "")
  );



  const estimationAmount = Number(
    String(data.EstimationAmount || "").replace(/,/g, "")
  );

// 09-10 error msg
const newErrors = {};
 if (!data.FinancialYear) {

  newErrors.FinancialYear = "Financial Year is required";

}
 
if (!data.ProjectID) {

  newErrors.ProjectID = "Project is required";

}

 
if (!data.ContractorName) {
  newErrors.ContractorName = "Vendor Name is required";
}
 
if (!data.WorkName) {
  newErrors.WorkName = "Work Name is required";
}
 
if (!data.WorkOrderNo) {
  newErrors.WorkOrderNo = "Work Order No is required";
}
 
if (!data.WorkOrderDate) {
  newErrors.WorkOrderDate = "Work Order Date is required";
}
 
if (!data.WorkEndDate) {
  newErrors.WorkEndDate = "Work End Date is required";
}
 
if (!data.Account_Number) {
  newErrors.Account_Number = "Account Number is required";
}
 
if (!isEdit && !selectedCopyFile) {
  newErrors.CopyOfWorkOrder = "Please upload Copy of Work Order";
}
 
if (
  !data.ApprovedWorkAmount ||
  isNaN(approvedAmount) ||
  approvedAmount <= 0
) {
  newErrors.ApprovedWorkAmount =
    "Approved Work Amount is required";
}
 
if (Object.keys(newErrors).length > 0) {
  setErrors(newErrors);
  return;
}
 
setErrors({});




// 21-09

 
  if (loading) return;
 
  // Create mode me file mandatory hai
  if (!isEdit && !selectedCopyFile) {
    alert("Please upload Copy of Work Order");
    return;
  }


  // Prevent duplicate submission
  if (loading) return;


  // 18-09
  // const fileInput = document.getElementById("CopyOfWorkOrder");
  //  const file = fileInput?.files?.[0];
  //  21-09
 


  // Validation
  if (
    !data.ContractorName ||
    !data.WorkName ||
    !data.WorkOrderNo ||
    !data.WorkOrderDate ||
    !data.WorkEndDate
  ) {
    alert("Please fill all the fields");
    return;
  }
 

  // 28-09 approve amount cant 0
  if (!data.ApprovedWorkAmount || isNaN(approvedAmount) || approvedAmount <= 0) {
  alert("Approved Work Amount cannot be 0 or less than 0");
  return;
}

  if (approvedAmount > estimationAmount) {
    alert("Approved Work Amount cannot be greater than Estimation Amount");
    return;
  }

  setLoading(true);

  try {
  //   const formData = new FormData();

  //   // Add all form data
  //   Object.entries(data).forEach(([key, value]) => {
  //     formData.append(key, value ?? "");
  //   });

  //   // Create / Update
  //   formData.append("type", isEdit ? "Update" : "Create");

  //   // Work Order ID for update
  //   if (isEdit && projectDatainward?.WorkOrderID) {
  //     formData.append(
  //       "WorkOrderID",
  //       projectDatainward.WorkOrderID
  //     );
  //   }

  //   // Add file ONLY ONCE 18-09
  //   // formData.append("CopyOfWorkOrder", file);
  //   if (fileInput && fileInput.files.length > 0) {
  // formData.append(
  //   "CopyOfWorkOrder",
  //   fileInput.files[0]
  // );
// }

// 21-09
// const formData = new FormData();
 
// Object.entries(data).forEach(([key, value]) => {

//   if (key !== "CopyOfWorkOrder") {

//     formData.append(key, value ?? "");

//   }

// });
const formData = new FormData();

Object.entries(data).forEach(([key, value]) => {
  if (key === "CopyOfWorkOrder") return;

  if (key === "ApprovedWorkAmount" || key === "PaidAmount" || key === "RemainingAmount") {
    // strip commas so backend/DB stores a clean number
    const cleanValue = String(value ?? "").replace(/,/g, "");
    formData.append(key, cleanValue);
    return;
  }

  formData.append(key, value ?? "");
});
 
formData.append("type", isEdit ? "Update" : "Create");
 
if (isEdit && projectDatainward?.WorkOrderID) {

  formData.append("WorkOrderID", projectDatainward.WorkOrderID);

}
 


if (selectedCopyFile) {

  formData.append("CopyOfWorkOrder", selectedCopyFile);

}
 
    // const fileInput = document.getElementById("CopyOfWorkOrder");
    // const file = fileInput?.files?.[0];

    // if (file) {
    //   formData.append("CopyOfWorkOrder", file);
    // }

    // Check API execution time
    console.time("WorkOrderCreation");

    const result = await WorkOrderCreation(formData);

    console.timeEnd("WorkOrderCreation");

    console.log("Work Order Response:", result);

    if (result?.message) {
      alert(result.message);

      if (isEdit) {
        onSuccess();
      } else {
        window.location.reload();
      }
    }
  } catch (error) {
    console.error("Work Order Creation Error:", error);
    alert("Something went wrong while saving the Work Order.");
  } finally {
    setLoading(false);
  }
};
  const FetchData = async () => {
    setLoading(true);
    try {
      let res = await GetProjectInfo("null", "WorkOrderProjects"); //29-09 fethcing
      console.log("All Projects fetched:", res);
      let res2 = await GetProjectInfo("null", "Contractor");
      let res1 = await GetBudgetHeadInfo("null", "all");

      console.log("All BudgetHeads fetched:", res1);

      // setProjectId(res);
      setAllProjects(res); // FOR THE YEAR WISE PROJECTS
      setHeadID(res1);
      setContractor(res2);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const uniqueHeads = [];

  const filteredData = HeadId.filter((item) => {
    const isDuplicate = uniqueHeads.includes(item.HeadName);
    if (!isDuplicate) {
      uniqueHeads.push(item.HeadName);
      return true;
    }
    return false;
  });

  const HeadIDFetchOperation = async (ID, IDtype) => {
    try {
      console.log(ID);
      if (IDtype == "HeadID") {
        let res1 = await GetBudgetHeadInfo(ID, "id");
        console.log("Head ID info ", res1);
        let HeadData = res1[0];
        console.log("head data related to Head ", HeadData);

        setData((prev) => ({
          ...prev,
          BudgetHeadID: HeadData.HeadID,
          BudgetHeadName: HeadData.HeadName,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    FetchData();
  }, []);

  //FOR THE Year Wise Projects
  //Commented on 22june for budgethead
  // useEffect(() => {
  //   console.log("data", data);

  //   if (data.FinancialYear && data.FinancialYear !== "null" && data.BudgetHeadID && data.BudgetHeadID !== "null") {
  //     console.log("succ", allProjects);

  //     const filtered = allProjects.filter(
  //       (project) =>
  //         String(project.FinancialYear) === String(data.FinancialYear) &&
  //         String(project.HeadID) === String(data.BudgetHeadID)
  //     );

  //     console.log("Filtered Projects:", filtered);

  //     setProjectId(filtered);

  //   } else {
  //     setProjectId([]);
  //   }
  // }, [data.FinancialYear, data.BudgetHeadID, allProjects]);
  // ======================== 26-08-2026
  // useEffect(() => {
  //   if (data.FinancialYear && data.FinancialYear !== "null") {
  //     const filtered = allProjects.filter(
  //       (project) => project.FinancialYear === data.FinancialYear,
  //     );

  //     setProjectId(filtered);
  //   } else {
  //     setProjectId(allProjects);
  //   }
  // }, [data.FinancialYear, allProjects]);

  // useEffect(() => {
  //   if (data.FinancialYear && data.FinancialYear !== "null") {
  //     const filtered = allProjects.filter(
  //       (project) =>
  //         String(project.FinancialYear).trim() ===
  //         String(data.FinancialYear).trim(),
  //     );
  //     console.log("ALL PROJECTS:", allProjects);
  //     console.log("FILTERED PROJECTS:", filtered);
  //     setProjectId(filtered);
  //   } else {
  //     setProjectId(allProjects);
  //   }
  // }, [data.FinancialYear, allProjects]);

  // comment on 04/09/2026 for unique project id
  useEffect(() => {
    let filtered = allProjects;

    // Financial Year filter
    if (data.FinancialYear && data.FinancialYear !== "null") {
      filtered = allProjects.filter(
        (project) =>
          String(project.FinancialYear).trim() ===
          String(data.FinancialYear).trim(),
      );
    }

    // Remove duplicate projects based on ProjectId
    const uniqueProjects = Array.from(
      new Map(
        filtered.map((project) => [String(project.ProjectId), project]),
      ).values(),
    );

    console.log("ALL PROJECTS:", allProjects);
    console.log("FILTERED PROJECTS:", filtered);
    console.log("UNIQUE PROJECTS:", uniqueProjects);

    setProjectId(uniqueProjects);
  }, [data.FinancialYear, allProjects]);

  // useEffect(() => {
  //   const approved = parseFloat(data.ApprovedWorkAmount || 0);
  //   const paid = parseFloat(data.PaidAmount || 0);
  //   const remaining = approved - paid;

  //   if (!isNaN(remaining) && remaining >= 0) {
  //     setData((prev) => ({
  //       ...prev,
  //       RemainingAmount: remaining,
  //     }));
  //   }
  // }, [data.ApprovedWorkAmount, data.PaidAmount]);

  // Fetch EstimationAmount whenever ProjectID or BudgetHeadID changes
  //Commented on 22june for budgethead
  // useEffect(() => {
  //   if (data.ProjectID && data.BudgetHeadID) {
  //     const fetchEstimation = async () => {
  //       try {
  //         const totalEstimation = await GetTotalEstimationForWorkOrder(data.ProjectID, data.BudgetHeadID);
  //         setData(prev => ({
  //           ...prev,
  //           EstimationAmount: totalEstimation || 0
  //         }));
  //       } catch (err) {
  //         console.error("Error fetching estimation amount:", err);
  //       }
  //     };
  //     fetchEstimation();
  //   }
  // }, [data.ProjectID, data.BudgetHeadID]);


  // useEffect(() => {
  //   if (data.ProjectID) {
  //     const fetchEstimation = async () => {
  //       try {
  //         const totalEstimation = await GetTotalEstimationForWorkOrder(
  //           data.ProjectID,
  //           data.BudgetHeadID,
  //           { type: "release" },
  //         );
  //         setData((prev) => ({
  //           ...prev,
  //           EstimationAmount: totalEstimation || 0,
  //         }));
  //         console.log("Fetched Estimation Amount:", totalEstimation);
  //       } catch (err) {
  //         console.error("Error fetching estimation amount:", err);
  //       }
  //     };
  //     fetchEstimation();
  //   }
  // }, [data.ProjectID,data.BudgetHeadID]);


//   useEffect(() => {
//   if (data.ProjectID) {
//     const fetchEstimation = async () => {
//       try {
//         const totalEstimation =
//           await GetTotalEstimationForWorkOrder(
//             data.ProjectID,
//             data.BudgetHeadID,
//             { type: "release" }
//           );

//         console.log("🔥 PROJECT ID:", data.ProjectID);
//         console.log("🔥 BUDGET HEAD ID:", data.BudgetHeadID);
//         console.log("🔥 AVAILABLE AMOUNT FROM API:", totalEstimation);

//         setData((prev) => ({
//           ...prev,
//           EstimationAmount: Number(totalEstimation) || 0,
//         }));
//       } catch (err) {
//         console.error("Error fetching estimation amount:", err);
//       }
//     };

//     fetchEstimation();
//   }
// }, [data.ProjectID, data.BudgetHeadID]);

// 16-10 for limit amount
useEffect(() => {
  if (!data.ProjectID) return;

  const fetchEstimation = async () => {
    try {
      const available =
        Number(
          await GetTotalEstimationForWorkOrder(
            data.ProjectID,
            data.BudgetHeadID,
            { type: "release" }
          )
        ) || 0;

      let limit = available;

      // Edit mode: add back this work order's own saved approved amount,
      // but only if project / budget head are still the original ones
      const isSameAsSaved =
        isEdit &&
        projectDatainward &&
        String(projectDatainward.ProjectID) === String(data.ProjectID) &&
        String(projectDatainward.BudgetHeadID || "") ===
          String(data.BudgetHeadID || "");

      if (isSameAsSaved) {
        const savedApproved = Number(
          String(projectDatainward.ApprovedWorkAmount || 0).replace(/,/g, "")
        );
        limit = available + savedApproved;
      }

      setData((prev) => ({
        ...prev,
        EstimationAmount: limit,
      }));
    } catch (err) {
      console.error("Error fetching estimation amount:", err);
    }
  };

  fetchEstimation();
}, [data.ProjectID, data.BudgetHeadID, isEdit, projectDatainward]);

  // 18-09
// useEffect(() => {
//   if (data.ProjectID && data.BudgetHeadID) {
//     const fetchEstimation = async () => {
//       try {
//         const totalEstimation =
//           await GetTotalEstimationForWorkOrder(
//             data.ProjectID,
//             data.BudgetHeadID,
//             { type: "release" }
//           );

//         console.log(
//           "🔥 AVAILABLE AMOUNT FROM API:",
//           totalEstimation
//         );

//         setData((prev) => ({
//           ...prev,
//           EstimationAmount: Number(totalEstimation) || 0,
//         }));

//       } catch (err) {
//         console.error(
//           "Error fetching estimation amount:",
//           err
//         );
//       }
//     };

//     fetchEstimation();
//   }
// }, [data.ProjectID, data.BudgetHeadID]);



  // const handleBudgetHeadChange = (e) => {
  //   const selectedHeadID = e.target.value;
  //   console.log("Selected Head ID:", selectedHeadID);
  //   console.log("All projects state:", allProjects);

  //   HandleChangeData(e); // sets BudgetHeadID in data state
  //   HeadIDFetchOperation(selectedHeadID, "HeadID"); // fetch Head name for selected HeadID

  //   // filter projects under this head
  //   const filteredProjects = allProjects.filter(
  //     (project) => String(project.HeadID) === String(selectedHeadID) &&
  //       String(project.FinancialYear) === String(data.FinancialYear)
  //   );
  //   console.log("Filtered Projects:", filteredProjects)
  //   setProjectId(filteredProjects); // now ProjectId dropdown will show only projects under this Head
  // };

  const handleBudgetHeadChange = (e) => {
    const selectedHeadID = e.target.value;

    HandleChangeData(e);

    HeadIDFetchOperation(selectedHeadID, "HeadID");
  };

  // const handleProjectChange = (e) => {
  //   const selectedProjectID = e.target.value;
  //   console.log("Selected projectt ID:", selectedProjectID);
  //   HandleChangeData(e); // sets ProjectID in data state
  //   HeadIDFetchOperation(selectedProjectID, "ProjectId"); // fill FinancialYear, ProjectName etc.
  // };

  const handleProjectChange = (e) => {
    const selectedProjectID = e.target.value;
    // 23-10
    if (!selectedProjectID) {
    setData((prev) => ({
      ...prev,
      ProjectID: "",
      ProjectName: "",
      ProjectCost: "0",
      piu: "",
      GRCopy: "",
      ProjectEstCompletionDate: "", EstimationAmount: 0, ApprovedWorkAmount: 0,  PaidAmount: 0,  RemainingAmount: 0, })); return;}
    const selectedProject = allProjects.find(
      (project) => String(project.ProjectId) === String(selectedProjectID),
    );
    if (!selectedProject) 
      return;
    setData((prev) => ({
      ...prev,
      ProjectID: selectedProject.ProjectId,
      // FinancialYear: selectedProject.FinancialYear, 01/10
      ProjectName: selectedProject.ProjectName,
      ProjectCost: selectedProject.ProjectCost,
      piu: selectedProject.Agency_Name,
      GRCopy: selectedProject.GRCopy,
      ProjectEstCompletionDate: selectedProject.ProjectEstCompletionDate,
      Scheme: selectedProject.Scheme || prev.Scheme,
    }));
  };
  useEffect(() => {
    if (isEdit && projectDatainward) {
      setData({
        FinancialYear:
          projectDatainward.FinancialYear ||
          projectDatainward.FinancialYear ||
          "",

        ProjectID:
          projectDatainward.ProjectID || projectDatainward.ProjectID || "",

        ProjectName: projectDatainward.ProjectName || "",

        ProjectCost: projectDatainward.ProjectCost || "",

        piu: projectDatainward.PIU || "",

        GRCopy: projectDatainward.GRCopy || "",

        BudgetHeadID: projectDatainward.BudgetHeadID || "",

        BudgetHeadName: projectDatainward.BudgetHeadName || "",

        ContractorName: projectDatainward.ContractorName || "",

        Account_Number: projectDatainward.Account_Number || "",

        WorkName: projectDatainward.WorkName || "",

        WorkOrderNo: projectDatainward.WorkOrderNo || "",

        WorkOrderDate: getMinDateTime(projectDatainward.WorkOrderDate || ""),

        WorkEndDate: getMinDateTime(projectDatainward.WorkEndDate || ""),

        ApprovedWorkAmount: projectDatainward.ApprovedWorkAmount || "",

        PaidAmount: projectDatainward.PaidAmount || "",

        RemainingAmount: projectDatainward.RemainingAmount || "",
        
  CopyOfWorkOrder:
  projectDatainward.CopyofWorkOrder ||
  projectDatainward.CopyOfWorkOrder ||
  "",// 21-09
      });
    }
  }, [isEdit, projectDatainward]);
// 18-09

useEffect(() => {
  const limitAllocated = Number(
    String(data.EstimationAmount || 0).replace(/,/g, "")
  );

  const approvedWork = Number(
    String(data.ApprovedWorkAmount || 0).replace(/,/g, "")
  );

  const paidAmount = Number(
    String(data.PaidAmount || 0).replace(/,/g, "")
  );

  const remainingAmount =
    limitAllocated - approvedWork - paidAmount;

  setData((prev) => ({
    ...prev,
    RemainingAmount: remainingAmount > 0
      ? remainingAmount
      : 0,
  }));
}, [
  data.EstimationAmount,
  data.ApprovedWorkAmount,
  data.PaidAmount,
]);

// 05-10 for cancel
const handleCancel = () => {
  const confirmCancel = window.confirm(
    "Are you sure you want to cancel?"
  );
 
  if (confirmCancel) {
    setData({
      FinancialYear: "",
      ProjectName: "",
      ProjectID: "",
      ProjectCost: "0",
      piu: "",
      GRCopy: "",
      ProjectEstCompletionDate: "",
      BudgetHeadID: "",
      BudgetHeadName: null,
      ContractorName: "",
      Account_Number: "",
      WorkName: "",
      WorkOrderNo: "",
      WorkOrderDate: "",
      WorkEndDate: "",
      ApprovedWorkAmount: 0,
      EstimationAmount: 0,
      PaidAmount: 0,
      RemainingAmount: 0,
      Scheme: "",
      CopyOfWorkOrder: "",
    });
 
    setSelectedCopyFile(null);
    setRemoveCopyFile(false);
  }
};
 
const errorStyle = {
  color: "#dc3545",
  fontSize: "12px",
  marginTop: "4px",
  display: "block",
  fontWeight: "500",
};
  return (
    <>
      <div
       style={{
          width: "100%",
          height:"90vh",
          overflowY: "auto",
          //29/10
          background: "white",
          padding: "0 30px 30px",
          boxSizing: "border-box",
          fontFamily: "Inter, sans-serif",
        }}
      >
        <div
          style={{
                width: "100%",
            height: "58px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            //29/10
            marginBottom: "5px",
            marginTop:"10px"
          }}
        >
          <i
            className="fa fa-user"
            style={{
              color: "#044c92",
              fontSize: "18px",
            }}
          ></i>
          <h5
            style={{
              margin: 0,
              color: "#111",
              fontWeight: 700,
              fontSize: "18px",
            }}
          >
            Work Order Details
          </h5>
        </div>

        <form 
        onSubmit={handleSubmit}
             //29/10
          style={{
    width: "94%",
    backgroundColor: "#ffffff",
    borderRadius: "15px",
    padding: "20px",
    boxSizing: "border-box",
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.12)",
    margin: "0 auto 20px",
  }}
        >
          <div
            style={{
              width: "100%",
              backgroundColor: "#EEF1F6",
              border: "none",
              borderRadius: "15px",
              padding: "22px 28px",
              boxSizing: "border-box",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              columnGap: "20px",
              rowGap: "15px",
            }}
          >
            {/* Financial Year */}
            {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
                marginRight: "200px",
              }}
            >
              <label
                className="form-label"
                style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  width: "200px",
                  textAlign: "left",
                }}
              >
                Financial Year:
              </label>
              <select
                name="FinancialYear"
                value={data.FinancialYear}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                  flex: "1",
                  //  marginRight: "20px",
                  textAlign: "left",
                }}
                className="form-control py-2"
                onChange={HandleChangeData}
              >
                <option value="">Choose Financial Year</option>
                <option value="2024-2025">2024 - 2025</option>
                <option value="2025-2026">2025 - 2026</option>
                <option value="2026-2027">2026 - 2027</option>
              </select>
            </div> */}

            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Financial Year:
              </label>

              <div style={{ flex: 1 }}>
                {/* <Select
                  options={[
                    { value: "2024-2025", label: "2024 - 2025" },
                    { value: "2025-2026", label: "2025 - 2026" },
                    { value: "2026-2027", label: "2026 - 2027" },
                  ]}
                  value={
                    data.FinancialYear
                      ? {
                          value: data.FinancialYear,
                          label:
                            data.FinancialYear === "2024-2025"
                              ? "2024 - 2025"
                              : data.FinancialYear === "2025-2026"
                                ? "2025 - 2026"
                                : "2026 - 2027",
                        }
                      : null
                  }
                  onChange={(selected) =>
                    HandleChangeData({
                      target: {
                        name: "FinancialYear",
                        value: selected ? selected.value : "",
                      },
                    })
                  }
                  placeholder="Choose Financial Year"
                  isSearchable
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      // height:"40px",
                      minHeight: "40px",
                      borderRadius: "10px",
                      fontSize: "12px",
                      boxSizing:"border-box"
                    }),
                  }}
                /> */}
                {/* 01-10 */}
                <Select
  options={[
    { value: "2024-2025", label: "2024 - 2025" },
    { value: "2025-2026", label: "2025 - 2026" },
    { value: "2026-2027", label: "2026 - 2027" },
  ]}
  value={
    [
      { value: "2024-2025", label: "2024 - 2025" },
      { value: "2025-2026", label: "2025 - 2026" },
      { value: "2026-2027", label: "2026 - 2027" },
    ].find(
      (option) =>
        option.value === String(data.FinancialYear).trim()
    ) || null
  }
  onChange={(selected) => {
    const financialYear = selected?.value || "";

    console.log("Selected Financial Year:", financialYear);

    setData((prev) => ({
      ...prev,
      FinancialYear: financialYear,
      ProjectID: "",
      ProjectName: "",
      ProjectCost: "0",
      piu: "",
      GRCopy: "",
      ProjectEstCompletionDate: "",
    }));
  }}
  placeholder="Choose Financial Year"
  isSearchable
  isClearable
  styles={{
    control: (base) => ({
      ...base,
      minHeight: "40px",
      borderRadius: "10px",
      fontSize: "12px",
      boxSizing: "border-box",
    }),
  }}
/> 
 {errors.FinancialYear && (
      <span style={errorStyle}>
        {errors.FinancialYear}
      </span>
    )}


              </div>
            </div>

            {/* Budget Head */}
            {Scheme === "Budget" && (
              <div
                style={{
                  width: "100%",
                  minWidth: 0,
                  boxSizing: "border-box",
                  margin: 0,
                }}
              >
                <label
                  className="form-label"
                  style={{
                    display: "block",
                    width: "100%",
                    marginBottom: "6px",
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#111",
                    textAlign: "left",
                  }}
                >
                  Budget Head:
                </label>
                <select
                  name="BudgetHeadID"
                  value={data.BudgetHeadID}
                  className="form-control py-2"
                  onChange={handleBudgetHeadChange}
                   style={{ width: "100%", height: "40px",border: "1px solid #c7c0c0",   borderRadius: "10px",  padding: "7px 10px",  boxSizing: "border-box",  fontSize: "12px", }} >
                  <option value="">Choose Budget Head</option>
                  {HeadId.map((val, index) => (
                    <option key={index} value={val.HeadID}>
                      {val.CRC}/{val.HeadName}
                    </option>
                  ))}
                </select>

              </div>
            )}
            {/* Project */}
            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Project:
              </label>
              {/* <select
                name="ProjectID"
                className="form-control py-2"
                value={data.ProjectID}
                onChange={handleProjectChange}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                  flex: "1",
                }}
              >
                <option value="">Choose Project</option>
                {projectId.map((val, index) => (
                  <option key={index} value={val.ProjectId}>
                    {val.ProjectName}
                  </option>
                ))}
              </select> */}
              <Select
                options={projectId.map((val) => ({
                  value: val.ProjectId,
                  label: val.ProjectName,
                }))}
                value={
                  projectId
                    .map((val) => ({
                      value: val.ProjectId,
                      label: val.ProjectName,
                    }))
                    .find(
                      (option) =>
                        String(option.value) === String(data.ProjectID),
                    ) || null
                }
                onChange={(selectedOption) => {
                  const projectID = selectedOption ? selectedOption.value : "";
                  handleProjectChange({
                    target: { name: "ProjectID", value: projectID },
                  });
                }}
                placeholder="Choose Project"
                isSearchable
                isClearable
                noOptionsMessage={() => "No project found"}
                styles={{
                  container: (base) => ({ ...base, width: "100%", flex: 1,fontSize:"12px" }),
                   control: (base) => ({
                  ...base,
                  height: "40px",
                  minHeight: "40px",
                  border: "1px solid #c7c0c0",
                  borderRadius: "10px",
                  boxShadow: "none",
                  width: "100%",
                  boxSizing: "border-box",

                }),
                }}
              /> 
{errors.ProjectID && (
<span style={errorStyle}>{errors.ProjectID}</span>

)}
            </div>

            {/* Project Cost */}
            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Project Cost:
              </label>
              <p  style={{ width: "100%", height: "40px",border: "1px solid #c7c0c0", borderRadius: "10px", padding: "7px 10px", backgroundColor: "#cccccc", opacity: "0.6", fontSize: "12px", boxSizing: "border-box",   margin: 0, display: "flex", alignItems: "center", }}>
                {/* {data.ProjectCost} */}
                {Number(data.ProjectCost || 0).toLocaleString("en-IN")}
              </p>
            </div>
            {/* PIU */}
            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Implementing Agency :
              </label>
              <p style={{ width: "100%", height: "40px",border: "1px solid #ccc",borderRadius: "10px", padding: "7px 10px",  backgroundColor: "#cccccc", opacity: "0.6",fontSize: "14px", boxSizing: "border-box",  margin: 0, display: "flex", alignItems: "center",}} >
                {data.piu ? data.piu : "--"}
              </p>
            </div>
            {/* GR Copy : */}
            <div  style={{  width: "100%", minWidth: 0,  boxSizing: "border-box", margin: 0, }} >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                GR Copy :
              </label>
              <div style={{ width: "100%", height: "40px", padding: "7px 10px", boxSizing: "border-box", margin: 0, display: "flex", alignItems: "center", border: "1px solid #ccc", borderRadius: "10px", backgroundColor: "#ffffff", boxSizing: "border-box", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", fontSize: "12px",}} >
                <a
                  href={`${apiurl}/ProjectDocsImages/${data.GRCopy}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "#1677ff",
                    textDecoration: "underline",
                  }}
                >
                  {data.GRCopy || " "}
                </a>
              </div>
            </div>
            {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
                marginRight: "200px",
              }}
            >
              <label
                className="form-label"
                style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  width: "200px",
                  textAlign: "left",
                }}
              >
                Vendor Name:
              </label>
              <select
                name="ContractorName"
                value={data.ContractorName}
                className="form-select py-2"
                onChange={(e) => {
                  HandleChangeData(e);
                  const selected = Contractor.find(
                    (c) => c.Bidder_CompanyName === e.target.value,
                  );
                  if (selected) {
                    setData((prev) => ({
                      ...prev,
                      ContractorName: selected.Bidder_CompanyName,
                      Account_Number: selected.Account_Number, // auto bind account
                    }));
                  }
                }}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                  flex: "1",
                }}
              >
                <option value="">Choose Vendor</option>
                {[
                  ...new Set(Contractor.map((val) => val.Bidder_CompanyName)),
                ].map((name, index) => (
                  <option key={index} value={name}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
                marginRight: "200px",
              }}
            >
              <label
                className="form-label"
                style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  width: "200px",
                  textAlign: "left",
                }}
              >
                Choose Vendor Account Number:
              </label>
              <select
                name="Account_Number"
                value={data.Account_Number || ""}
                className="form-select py-2"
                onChange={HandleChangeData}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                  flex: "1",
                }}
              >
                <option value="">Choose Account Number</option>
                {Contractor &&
                  Contractor.filter(
                    (c) => c.Bidder_CompanyName === data.ContractorName,
                  ).map((val, index) => (
                    <option key={index} value={val.Account_Number}>
                      {val.Account_Number}
                    </option>
                  ))}
              </select>
            </div> */}

            {/* //new dropdown ---22-08 */}
            {/* <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "600",


                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Vendor Name:
              </label>

              <div style={{ flex: 1 }}>
                <Select
                  options={[
                    ...new Set(
                      Contractor?.map((val) => val.Bidder_CompanyName).filter(
                        Boolean,
                      ),
                    ),
                  ].map((name) => ({
                    value: name,
                    label: name,
                  }))}
                  value={
                    data.ContractorName
                      ? {
                          value: data.ContractorName,
                          label: data.ContractorName,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    setData((prev) => ({
                      ...prev,
                      ContractorName: selected ? selected.value : "",
                      Account_Number: "",
                    }));
                  }}
                  placeholder="Choose Vendor"
                  isSearchable
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "38px",
                      borderRadius: "5px",
                      fontSize: "14px",
                    }),
                  }}
                />
              </div>
            </div> */}
{/* below dropdown atomatically fetch the account number afer selectthe vendor name ---16-09 */}
<div
  style={{
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    margin: 0,
  }}
>
  <label
    className="form-label"
    style={{
      display: "block",
      width: "100%",
      marginBottom: "6px",
      fontWeight: "700",
      fontSize: "14px",
      color: "#111",
      textAlign: "left",
    }}
  >
    Vendor Name:
  </label>

  <div style={{ flex: 1 }}>
    <Select
      options={[
        ...new Set(
          Contractor?.map((val) => val.Bidder_CompanyName).filter(
            Boolean,
          ),
        ),
      ].map((name) => ({
        value: name,
        label: name,
      }))}
      value={
        data.ContractorName
          ? {
              value: data.ContractorName,
              label: data.ContractorName,
            }
          : null
      }
      onChange={(selected) => {
        const selectedVendor = selected ? selected.value : "";

        // find the matching contractor record to auto-fill account number
        const matchedContractor = Contractor?.find(
          (c) => c.Bidder_CompanyName === selectedVendor,
        );

        setData((prev) => ({
          ...prev,
          ContractorName: selectedVendor,
          Account_Number: matchedContractor
            ? matchedContractor.Account_Number
            : "",
        }));
      }}
      placeholder="Choose Vendor"
      isSearchable
      isClearable
      styles={{
       control: (base) => ({
  ...base,
  height: "40px",
  minHeight: "40px",
  borderRadius: "10px",
  fontSize: "12px",
  boxSizing: "border-box",
}),
      }}
    /> {errors.ContractorName && (
  <span style={errorStyle}>{errors.ContractorName}</span>
)}
  </div>
</div>

{/* comment in 15-09 --we have choose the account number from dropdown */}
            {/* <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "600",


                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Choose Vendor Account Number:
              </label>

              <div style={{ flex: 1 }}>
                <Select
                  options={Contractor?.filter(
                    (val) =>
                      val.Bidder_CompanyName === data.ContractorName &&
                      val.Account_Number,
                  ).map((val) => ({
                    value: val.Account_Number,
                    label: val.Account_Number,
                  }))}
                  value={
                    data.Account_Number
                      ? {
                          value: data.Account_Number,
                          label: data.Account_Number,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    HandleChangeData({
                      target: {
                        name: "Account_Number",
                        value: selected ? selected.value : "",
                      },
                    })
                  }
                  placeholder={
                    data.ContractorName
                      ? "Choose Account Number"
                      : "First Choose Vendor"
                  }
                  isSearchable
                  isClearable
                  isDisabled={!data.ContractorName}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "38px",
                      borderRadius: "5px",
                      fontSize: "14px",
                    }),
                  }}
                />
              </div>
            </div> */}

            {/* this automatically fetch the account number after slecting vendor */}
             <div
                style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Choose Vendor Account Number:
              </label>
              <select
                name="Account_Number"
                value={data.Account_Number || ""}
               className={`form-select py-2 ${
    !data.Account_Number ? "account-placeholder" : ""
  }`}
                onChange={HandleChangeData}
               
                styles={{
                   container: (base) => ({ ...base, width: "100%", flex: 1 , fontSize:"12px"}),
                    control: (base) => ({
                      ...base,
                    height: "40px",

minHeight: "40px",
borderRadius: "10px",
fontSize: "12px",
boxSizing: "border-box",
    fontSize: data.Account_Number ? "10px" : "7px", // smaller only while placeholder shown
  }),  }}>
                <option value="" style={{fontSize:"12px"}}>Choose Account Number</option>
                {Contractor &&
                  Contractor.filter(
                    (c) => c.Bidder_CompanyName === data.ContractorName,
                  ).map((val, index) => (
                    <option key={index} value={val.Account_Number}>
                      {val.Account_Number}
                    </option>
                  ))}
              </select>
            </div>
            {/* Work Name */}
            {/* <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Work Name:
              </label>
              <input
                type="text"
                placeholder="Enter Work Name"
                className="form-control py-2"
                name="WorkName"
                value={data.WorkName || ""}
                onChange={HandleChangeData}
                 style={{ width: "100%", height: "40px", border: "1px solid #ccc",  borderRadius: "10px", padding: "7px 10px", boxSizing: "border-box", fontSize: "12px",}}
              />
            </div> */}

            {/* Work Order No */}
            {/* <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Work Order No:
              </label>
              <input
                type="text"
                placeholder="Enter Work Order Number"
                className="form-control py-2"
                name="WorkOrderNo"
                value={data.WorkOrderNo}
                onChange={HandleChangeData}
                style={{ width: "100%", height: "40px",border: "1px solid #ccc", borderRadius: "10px",  padding: "7px 10px",boxSizing: "border-box", fontSize: "12px",}}
              />
            </div> */}
            {/* Work Name */}
 <div
  style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
>
<label
     style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
>
    Work Name:
</label>
 
  <input
    type="text"
    name="WorkName"
    placeholder="Enter Work Name"
    value={data.WorkName || ""}
    onChange={(e) => {
      console.log("WorkName:", e.target.value);
      setData((prev) => ({
        ...prev,
        WorkName: e.target.value,
      }));
    }}
    style={{ width: "100%", height: "40px", border: "1px solid #ccc",  borderRadius: "10px", padding: "7px 10px", boxSizing: "border-box", fontSize: "12px",}}
  /> {errors.WorkName && (
  <span style={errorStyle}>{errors.WorkName}</span>
)}
</div>
 
{/* Work Order No */}
<div
   style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
>
<label
    style={{
      display: "block",
      width: "100%",
      marginBottom: "6px",
      fontWeight: "700",
      fontSize: "14px",
      color: "#111",
      textAlign: "left",
    }}
>
    Work Order No:
</label>
 
  <input
    type="text"
    name="WorkOrderNo"
    placeholder="Enter Work Order Number"
    value={data.WorkOrderNo || ""}
    onChange={(e) => {
      console.log("WorkOrderNo:", e.target.value);
      setData((prev) => ({
        ...prev,
        WorkOrderNo: e.target.value,
      }));
    }}
   style={{ width: "100%", height: "40px",border: "1px solid #ccc", borderRadius: "10px",  padding: "7px 10px",boxSizing: "border-box", fontSize: "12px",}}
  /> {errors.WorkOrderNo && (
  <span style={errorStyle}>{errors.WorkOrderNo}</span>
)}
</div>   
 

            {/* Work Order Date */}
            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Work Order Date:
              </label>
            <div style={{ display: "flex", gap: "8px" }}>
 
{/* Work Order Date */}
<input
  type="datetime-local"
  className="form-control py-2"
  name="WorkOrderDate"
  value={toLocalInput(data.WorkOrderDate)}
  min={isEdit ? undefined : minDateTime}
  max="9999-12-31T23:59"
  onChange={handleDateTimeChange}
  style={{
    width: "100%",
    height: "40px",
    border: "1px solid #ccc",
    borderRadius: "10px",
    padding: "7px 10px",
    boxSizing: "border-box",
    fontSize: "12px",
  }}
/>

</div>{errors.WorkOrderDate && (
  <span style={errorStyle}>{errors.WorkOrderDate}</span>
)}
 
            </div>

            {/* Work End Date */}
            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Work End Date:
              </label>
             <div style={{ display: "flex", gap: "8px" }}>
  {/* 27-10 */}
 {/* Work End Date */}
<input
  type="datetime-local"
  className="form-control py-2"
  name="WorkEndDate"
  value={toLocalInput(data.WorkEndDate)}
  min={toLocalInput(data.WorkOrderDate) || (isEdit ? undefined : minDateTime)}
  max="9999-12-31T23:59"
  onChange={handleDateTimeChange}
  style={{
    width: "100%",
    height: "40px",
    border: "1px solid #ccc",
    borderRadius: "10px",
    padding: "7px 10px",
    boxSizing: "border-box",
    fontSize: "12px",
  }}
/>
</div>
             {errors.WorkEndDate && (
  <span style={errorStyle}>{errors.WorkEndDate}</span>
)}
 
            </div>

            {/*  Estimation Amount */}
            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Limit Allocated Amount :
              </label>
              <input
                type="text"
                name="EstimationAmount"
                //  value={data.EstimationAmount}
                value={Number(data.EstimationAmount || 0).toLocaleString(
                  "en-IN",
                )}
                readOnly
                className="form-control py-2"
                style={{ width: "100%", height: "40px",border: "1px solid #ccc", borderRadius: "10px",  padding: "7px 10px",boxSizing: "border-box", fontSize: "12px",}}
         
              />
            </div>
            {/* Approved Work Amount */}

            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Approved Work Amount:
              </label>
              {/* <input
                type="text"
                placeholder="Enter Approved Work Amount"
                className="form-control py-2"
                name="ApprovedWorkAmount"
                // value={data.ApprovedWorkAmount}
                value={
                  data.ApprovedWorkAmount !== "" &&
                  data.ApprovedWorkAmount !== null
                    ? Number(
                        String(data.ApprovedWorkAmount).replace(/,/g, ""),
                      ).toLocaleString("en-IN")
                    : ""
                }
                //  onChange={HandleChangeData}
                onChange={(e) => {
                  const value = e.target.value.replace(/,/g, "");
                  HandleChangeData({
                    target: {
                      name: "ApprovedWorkAmount",
                      value: value,
                    },
                  });
                }}
                style={{ width: "100%", height: "40px",border: "1px solid #ccc", borderRadius: "10px",  padding: "7px 10px",boxSizing: "border-box", fontSize: "12px",}}
         
              /> */}
              {/* 21-09 */}
     <input
  type="text"
  name="ApprovedWorkAmount"
  value={data.ApprovedWorkAmount || ""}
  onChange={(e) => {
    let value = e.target.value;

    // Remove commas
    value = value.replace(/,/g, "");

    // Allow only numbers and one decimal point
    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    const parts = value.split(".");
    let integerPart = parts[0];
    const decimalPart = parts[1];

    // Indian comma formatting WITHOUT converting to Number
    if (integerPart.length > 3) {
      const lastThree = integerPart.slice(-3);
      const remaining = integerPart.slice(0, -3);

      integerPart =
        remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        "," +
        lastThree;
    }

    const formattedValue =
      decimalPart !== undefined
        ? `${integerPart}.${decimalPart}`
        : integerPart;

    setData((prev) => ({
      ...prev,
      ApprovedWorkAmount: formattedValue,
    }));
  }}
  onKeyDown={(e) => {
    if (
      !/[0-9.]/.test(e.key) &&
      !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
        e.key
      )
    ) {
      e.preventDefault();
    }
  }}
  style={{
    width: "100%",
    height: "38px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "6px 10px",
    boxSizing: "border-box",
    fontSize: "14px",
  }}
/>
{errors.ApprovedWorkAmount && (
  <span style={errorStyle}>
    {errors.ApprovedWorkAmount}
  </span>
)}
            </div>
            {/* Paid Amount */}

            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Paid Amount:
              </label>
              {/* <input
                type="text"
                placeholder="Enter Paid Amount"
                className="form-control py-2"
                name="PaidAmount"
                //  value={data.PaidAmount}
                value={
                  data.PaidAmount !== "" && data.PaidAmount !== null
                    ? Number(
                        String(data.PaidAmount).replace(/,/g, ""),
                      ).toLocaleString("en-IN")
                    : ""
                }
                max={data.ApprovedWorkAmount || undefined}
                // onChange={HandleChangeData}
                //                onChange={(e) => {
                //   const paidAmount = Number(e.target.value);
                //   const approvedAmount = Number(data.ApprovedWorkAmount);

                //   if (
                //     e.target.value !== "" &&
                //     approvedAmount > 0 &&
                //     paidAmount > approvedAmount
                //   ) {
                //     return;
                //   }

                //   HandleChangeData(e);
                // }}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/,/g, "");

                  const paidAmount = Number(rawValue);
                  const approvedAmount = Number(
                    String(data.ApprovedWorkAmount || 0).replace(/,/g, ""),
                  );

                  if (
                    rawValue !== "" &&
                    approvedAmount > 0 &&
                    paidAmount > approvedAmount
                  ) {
                    return;
                  }

                  HandleChangeData({
                    target: {
                      name: "PaidAmount",
                      value: rawValue,
                    },
                  });
                }}
              style={{ width: "100%", height: "40px",border: "1px solid #ccc", borderRadius: "10px",  padding: "7px 10px",boxSizing: "border-box", fontSize: "12px",}}
         
              /> */}
              {/* 21-09 */}
        <input
  type="text"
  name="PaidAmount"
  value={data.PaidAmount || ""}
  onChange={(e) => {
    let value = e.target.value;

    // Remove existing commas
    value = value.replace(/,/g, "");

    // Allow only numbers and one decimal point
    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    const parts = value.split(".");
    let integerPart = parts[0];
    const decimalPart = parts[1];

    // Indian number formatting without Number()
    // This supports very large numbers safely
    if (integerPart.length > 3) {
      const lastThree = integerPart.slice(-3);
      const remaining = integerPart.slice(0, -3);

      integerPart =
        remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        "," +
        lastThree;
    }

    const formattedValue =
      decimalPart !== undefined
        ? `${integerPart}.${decimalPart}`
        : integerPart;

    setData((prev) => ({
      ...prev,
      PaidAmount: formattedValue,
    }));
  }}
  onKeyDown={(e) => {
    if (
      !/[0-9.]/.test(e.key) &&
      ![
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ].includes(e.key)
    ) {
      e.preventDefault();
    }
  }}
  style={{
    width: "100%",
    height: "38px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "6px 10px",
    boxSizing: "border-box",
    fontSize: "14px",
  }}
/>
            </div>
            {/* Remaining Amount */}
            {/* <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "600",


                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Remaining Amount:
              </label>
              <input
                type="number"
                placeholder="Enter Remaining Amount"
                className="form-control py-2"
                name="RemainingAmount"
                value={data.RemainingAmount}
                onChange={HandleChangeData}
                disabled
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                  flex: "1",
                  fontSize: "14px",
                }}
              />
            </div> */}
            <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Remaining Amount:
              </label>

              <input
                type="text"
                name="RemainingAmount"
                // value={data.RemainingAmount || 0}
                value={Number(data.RemainingAmount || 0).toLocaleString(
                  "en-IN",
                )}
                readOnly
                disabled
                className="form-control py-2"
                style={{ width: "100%", height: "40px",border: "1px solid #ccc", borderRadius: "10px",  padding: "7px 10px",boxSizing: "border-box", fontSize: "12px",}}
         
              />
            </div>
            {/* Copy of Work Order */}

            {/* <div
              style={{
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                margin: 0,
              }}
            >
              <label
                className="form-label"
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "10px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#111",
                  textAlign: "left",
                }}
              >
                Copy of Work Order:
              </label>
              <input
                type="file"
                className="form-control py-2"
                 required
                id="CopyOfWorkOrder"
               style={{ width: "100%", height: "40px",border: "1px solid #ccc", borderRadius: "10px",  padding: "7px 10px",boxSizing: "border-box", fontSize: "12px",}}
         
              />
            </div> */}
            {/* 21-09 */}
              <div
  style={{
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    margin: 0,
  }}
>
  <label
    style={{
      display: "block",
      width: "100%",
      marginBottom: "6px",
      fontWeight: "600",
      fontSize: "15px",
      color: "#111",
      textAlign: "left",
    }}
  >
    Copy of Work Order:
    <span style={{ color: "red" }}>*</span>
  </label>
 
 
  <div
    style={{
      width: "100%",
      height: "38px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      background: "#fff",
      display: "flex",
      alignItems: "center",
      overflow: "hidden",
    }}
  >
    {(selectedCopyFile ||
      (isEdit && data.CopyOfWorkOrder && !removeCopyFile)) ? (
      <>
        <a
          href={
            selectedCopyFile
              ? URL.createObjectURL(selectedCopyFile)
              : `${apiurl}/WorkOrderDocsImages/${data.CopyOfWorkOrder}`
          }
          target="_blank"
          rel="noreferrer"
          style={{
            flex: 1,
            paddingLeft: "10px",
            color: "#1677ff",
            textDecoration: "underline",
            fontSize: "14px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            cursor: "pointer",
          }}
          title="Click to open file"
        >
          {selectedCopyFile
            ? selectedCopyFile.name
            : data.CopyOfWorkOrder}
        </a>
 
        <button
          type="button"
          onClick={() => {
            setSelectedCopyFile(null);
            setRemoveCopyFile(true);
 
            setData((prev) => ({
              ...prev,
              CopyOfWorkOrder: "",
            }));
          }}
          style={{
            border: "none",
            background: "transparent",
            color: "grey",
            fontSize: "20px",
            fontWeight: "bold",
            cursor: "pointer",
            padding: "0 10px",
          }}
          title="Remove file"
        >
          ×
        </button>
      </>
    ) : (
      <input
        type="file"
        id="CopyOfWorkOrder"
        accept=".pdf,.jpg,.jpeg,.png"
        onChange={(e) => {
          const file = e.target.files?.[0];
 
          if (file) {
            setSelectedCopyFile(file);
            setRemoveCopyFile(false);
          }
        }}
        style={{
          width: "100%",
          height: "38px",
          padding: "6px 10px",
          border: "none",
          fontSize: "14px",
          boxSizing: "border-box",
        }}
      />
    )}
  </div>{errors.CopyOfWorkOrder && (
<span style={errorStyle}>{errors.CopyOfWorkOrder}</span>
)}
</div>
 
 
          </div>

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              marginTop: "20px",
              marginRight: "40px",
            }}
          >
            <button
              type="submit"
              disabled={loading}
             style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                //29/10
                borderRadius: "20px",
                width: "120px",
                height: "40px",
                backgroundColor: "#4EB65E",
                border: "none",
                fontSize: "16px",
                color: "#ffffff",
                fontWeight: "700",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.7 : 1,
              }}
              // onClick={handleSubmit}
            >
              {!loading && (
                <img
                  src={submit}
                  style={{
                    marginRight: "10px",
                    width: "1.2rem",
                    paddingBottom: "3px",
                    fontSize: "15px",
                  }}
                />
              )}
              {loading ? "Saving..." : projectDatainward ? "Update" : "Save"}
            </button>
            <button
             onClick={handleCancel}
              type="button"
             style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                //29/10
                borderRadius: "20px",
                width: "120px",
                height: "40px",
                backgroundColor: "#be1e0f",
                border: "none",
                fontSize: "16px",
                color: "#ffffff",
                fontWeight: "700",
              }}
            >
              <img
                src={Cancel32}
                style={{ marginRight: "10px", width: "1.2rem" }}
              />
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateWorkOrder;

